import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, ArrowRight } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatPrice } from "@/lib/api";

export const MobileStickyBar = () => {
  const { count, total } = useCart();
  const { pathname } = useLocation();

  // Hide on checkout / cart / admin pages
  if (["/finalizare", "/cos"].includes(pathname) || pathname.startsWith("/admin")) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/90 p-3 backdrop-blur-xl lg:hidden"
      data-testid="mobile-sticky-bar"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      {count > 0 ? (
        <Link
          to="/finalizare"
          className="flex items-center justify-between gap-3 rounded-full bg-primary px-5 py-3.5 text-white shadow-lg shadow-primary/25 active:scale-[0.99]"
          data-testid="mobile-checkout-btn"
        >
          <span className="flex items-center gap-2 text-sm font-semibold">
            <span className="relative">
              <ShoppingCart className="h-5 w-5" />
              <span className="absolute -right-2 -top-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-white px-1 text-[10px] font-black text-primary">{count}</span>
            </span>
            {formatPrice(total)}
          </span>
          <span className="flex items-center gap-1 font-bold">Finalizează comanda <ArrowRight className="h-4 w-4" /></span>
        </Link>
      ) : (
        <Link
          to="/magazin"
          className="flex items-center justify-center gap-2 rounded-full bg-primary px-5 py-3.5 font-bold text-white shadow-lg shadow-primary/25 active:scale-[0.99]"
          data-testid="mobile-order-btn"
        >
          <ShoppingCart className="h-5 w-5" /> Comandă acum
        </Link>
      )}
    </div>
  );
};
